// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Stacking layer for context menus, tooltips, and other anchored overlays. Sits above
 * .modalsContainer because it appears later in the DOM — both have z-index: 1, and among
 * siblings with equal z-index the later element wins.
 *
 * Cross-reference: Modal.css (.modalsContainer), index.html (DOM order),
 * hooks/index.tsx (overlayPortal, modalPortal), Popup.tsx, Modal.tsx.
 * Update all of these if the stacking strategy changes.
 */
.overlayContainer {
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1;
}

.menusFile {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ccc;
  box-sizing: border-box;
  box-shadow: 0 3px 11px #0002;
  border-radius: 3px;
  font-size: var(--density-font-size);
  --icon-size: var(--density-icon-size);
  overflow: hidden;
}

.menusFileButton {
  font-size: inherit;
  margin: 0;
  background: none;
  height: var(--density-touch-target);
  padding: 0 calc(var(--density-row-padding) + 5px);
  box-sizing: border-box;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 2px solid transparent;
  cursor: pointer;
}

.menusFileButtonLabel {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menusFileButtonShortcut {
  color: #666;
  flex: none;
  font-size: 0.86em;
}

.menusFileButton:focus,
.menusFileButton:active {
  background: #d0f4ff;
  border: var(--outline-active);
  border-radius: 3px;
  outline: none;
}

.menusFileButtonLabel > .icon {
  flex: none;
}

.menusFileButton:hover {
  background-color: #eee;
}

@keyframes menudown {
  from { opacity: 0; transform: translateY(-10px); pointer-events: none; }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes menuup {
  from { opacity: 0; transform: translateY(10px); pointer-events: none; }
  to   { opacity: 1; transform: translateY(0); }
}

.menusFileAnimateDown {
  animation: menudown 80ms;
}

.menusFileAnimateUp {
  animation: menuup 80ms;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Menus.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;AACF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE,oBAAoB,EAAE;EACvE,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE,oBAAoB,EAAE;EACtE,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/*\n * Stacking layer for context menus, tooltips, and other anchored overlays. Sits above\n * .modalsContainer because it appears later in the DOM — both have z-index: 1, and among\n * siblings with equal z-index the later element wins.\n *\n * Cross-reference: Modal.css (.modalsContainer), index.html (DOM order),\n * hooks/index.tsx (overlayPortal, modalPortal), Popup.tsx, Modal.tsx.\n * Update all of these if the stacking strategy changes.\n */\n.overlayContainer {\n  position: absolute;\n  width: 0;\n  height: 0;\n  z-index: 1;\n}\n\n.menusFile {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  box-shadow: 0 3px 11px #0002;\n  border-radius: 3px;\n  font-size: var(--density-font-size);\n  --icon-size: var(--density-icon-size);\n  overflow: hidden;\n}\n\n.menusFileButton {\n  font-size: inherit;\n  margin: 0;\n  background: none;\n  height: var(--density-touch-target);\n  padding: 0 calc(var(--density-row-padding) + 5px);\n  box-sizing: border-box;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  border: 2px solid transparent;\n  cursor: pointer;\n}\n\n.menusFileButtonLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.menusFileButtonShortcut {\n  color: #666;\n  flex: none;\n  font-size: 0.86em;\n}\n\n.menusFileButton:focus,\n.menusFileButton:active {\n  background: #d0f4ff;\n  border: var(--outline-active);\n  border-radius: 3px;\n  outline: none;\n}\n\n.menusFileButtonLabel > .icon {\n  flex: none;\n}\n\n.menusFileButton:hover {\n  background-color: #eee;\n}\n\n@keyframes menudown {\n  from { opacity: 0; transform: translateY(-10px); pointer-events: none; }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes menuup {\n  from { opacity: 0; transform: translateY(10px); pointer-events: none; }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.menusFileAnimateDown {\n  animation: menudown 80ms;\n}\n\n.menusFileAnimateUp {\n  animation: menuup 80ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
